import { Component, inject } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';
import { NavLoaderService } from '@core/services/nav-loader/nav-loader.service';

@Component({
  selector: 'd2d-global-nav-loader',
  standalone: true,
  imports: [ProgressSpinner],
  template: `
    @if (navLoader.loading()) {
      <div
        class="fixed inset-0 z-[9999] flex flex-col gap-4 items-center justify-center bg-black/20 backdrop-blur-[1px]"
      >
        <p-progressSpinner
          [style]="{ width: '54px', height: '54px' }"
          strokeWidth="4"
          ariaLabel="Cargando"
        />
        @if (navLoader.message()) {
          <p class="text-sm font-medium text-white drop-shadow">{{ navLoader.message() }}</p>
        }
      </div>
    }
  `,
})
export class GlobalNavLoaderComponent {
  readonly navLoader = inject(NavLoaderService);
}
